import React from 'react'
import { Helmet } from 'react-helmet'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'

interface Props {
  fields: {
    hreflangs: HrefLangsArray
  }
  sitecoreContext: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    route: any
    pageEditing: boolean
    'Discovery.Feature.Seo.CanonicalUrl': string
  }
}

interface HrefLangsArray {
  HrefLangs: HrefLang[]
}

interface HrefLang {
  Href: string
  Lang: string
}

const BasicMetaTags: React.FC<Props> = (props) => {
  const {
    fields,
    sitecoreContext,
    sitecoreContext: { route },
  } = props
  const canonicalUrl = sitecoreContext['Discovery.Feature.Seo.CanonicalUrl']

  return (
    <Helmet>
      <title>{route?.fields['Page Title']?.value}</title>
      <link rel="canonical" href={canonicalUrl} />
      <meta name="description" content={route?.fields['Meta Description']?.value} />
      <meta name="keywords" content={route?.fields['Meta Keywords']?.value} />
      <meta name="robots" content={route?.fields['Meta Robots']?.value} />

      {(fields.hreflangs?.HrefLangs || []).map((hreflang, index) => (
        <link href={hreflang.Href} rel="alternate" hrefLang={hreflang.Lang} key={index.toString()} />
      ))}
    </Helmet>
  )
}

export default withSitecoreContext()(withTranslation()(BasicMetaTags as React.FC) as React.FC)
